import { render } from "./OnlineIdentification.vue?vue&type=template&id=3753a9ee&scoped=true"
import script from "./OnlineIdentification.vue?vue&type=script&lang=js"
export * from "./OnlineIdentification.vue?vue&type=script&lang=js"

import "./OnlineIdentification.vue?vue&type=style&index=0&id=3753a9ee&lang=scss&scoped=true"

import exportComponent from "/Users/rulez/Dropbox/Projects/SimpleW/rulez/onboarding2101/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3753a9ee"]])

export default __exports__